import _slicedToArray from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { __rest } from "tslib";
import { useCombobox } from "downshift";
import isEqual from "lodash.isequal";
import xorWith from "lodash.xorwith";
import React, { forwardRef, useState } from "react";
import { Input } from "../Input";
import * as S from "./styles";
var Autocomplete = forwardRef(function (e, t) {
  var _e$suggestions = e.suggestions,
      o = _e$suggestions === void 0 ? [] : _e$suggestions,
      a = e.label,
      n = e.onInputValueChange,
      s = e.onSelectedItemChange,
      r = e.itemToString,
      _e$searchKey = e.searchKey,
      i = _e$searchKey === void 0 ? "" : _e$searchKey,
      l = e.stateReducer,
      u = e.initialInputValue,
      c = e.adavancedCompoboxProps,
      p = __rest(e, ["suggestions", "label", "onInputValueChange", "onSelectedItemChange", "itemToString", "searchKey", "stateReducer", "initialInputValue", "adavancedCompoboxProps"]),
      _useState = useState(o),
      _useState2 = _slicedToArray(_useState, 2),
      m = _useState2[0],
      g = _useState2[1],
      d = function d(e) {
    return e && "object" == typeof e ? e[i] : e || "";
  },
      h = null != r ? r : d,
      b = function b(e, t) {
    var o = new RegExp(t, "gi");
    return d(e).replace(o, function (e) {
      return "<mark>".concat(e, "</mark>");
    });
  },
      _useCombobox = useCombobox(Object.assign(Object.assign({}, c), {
    items: m,
    initialInputValue: u,
    onInputValueChange: n || function (e) {
      var t = e.inputValue;
      g(o.filter(function (e) {
        var o = new RegExp(t, "gi");
        return h(e).search(o) >= 0;
      }));
    },
    onSelectedItemChange: s,
    itemToString: h,
    stateReducer: null != l ? l : function (e, t) {
      var o = t.type,
          a = t.changes;
      return o === AutocompleteStateChangeTypes.InputChange ? Object.assign(Object.assign({}, a), {
        selectedItem: null
      }) : a;
    }
  })),
      I = _useCombobox.isOpen,
      C = _useCombobox.getMenuProps,
      x = _useCombobox.getInputProps,
      f = _useCombobox.getComboboxProps,
      R = _useCombobox.highlightedIndex,
      j = _useCombobox.getItemProps,
      y = _useCombobox.inputValue;

  return n && 0 !== xorWith(o, m, isEqual).length && g(o), React.createElement(S.AutocompleteContainer, Object.assign({}, f()), React.createElement(Input, Object.assign({}, x(Object.assign(Object.assign({}, p), {
    ref: t
  })), {
    label: a,
    type: "text"
  })), React.createElement(S.AutocompleteList, Object.assign({}, C(), {
    role: "listbox",
    hidden: !I || 0 === (null == m ? void 0 : m.length),
    "data-testid": "autocomplete-list",
    hasLabel: !!a
  }), I && m.map(function (e, t) {
    return React.createElement(S.AutocompleteListItem, Object.assign({
      key: "".concat(e).concat(t),
      id: "autoComplete_result_".concat(t),
      role: "option",
      "aria-selected": R === t,
      dangerouslySetInnerHTML: {
        __html: b(e, y)
      }
    }, j({
      item: e,
      index: t
    })));
  })));
});
export var AutocompleteStateChangeTypes = useCombobox.stateChangeTypes;
export default Autocomplete;